<template>
  <div class="table-responsive no-border table-header-middle">
    <p class="border-bottom p-h-sm m-t-n m-b-none" v-if="title">
      <span class="m-l">{{title}}</span>
    </p>
    <el-table ref="table" :data="tableData" :maxHeight="maxHeight" class="table table-stripped" stripe @selection-change="handleSelectionChange">
      <el-table-column
        v-if="selected"
        type="selection"
        width="40"
        labelClassName="thead-selection-none"
        align="center">
      </el-table-column>
      <el-table-column v-for="(column, index) in tableColumn" :key="index" :prop="column.prop" :label="column.label" :sortable="column.sortable" :width="column.width" :minWidth="column.minWidth" header-align="center" :align="column.align || 'center'" :className="column.className">

      </el-table-column>
    </el-table>
    <Pagination v-if="pageSize < recordTotal" :pageSize="pageSize" :total="recordTotal" :page="page" @current-change="handlePageChange" :simply="paginateSimply" />

  </div>
</template>
<script>
  export default {
    name: 'collisionTable',
    props: {
      paginateSimply: {
        type: Boolean,
        default: false
      },
      tableColumn: {
        type: Array,
        default: []
      },
      tableData: {
        type: Array,
        default: []
      },
      title: {
        type: String,
        default: ''
      },
      selected: {
        type: Boolean,
        default: false
      },
      maxHeight: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        pageSize: 20,
        recordTotal: 2,
        page: 1,
        multipleSelection: []
      }
    },
    mounted() {
    },
    methods: {
      handlePageChange(val) {},


      handleSelectionChange(val) {
        this.multipleSelection = val;
      }
    }

  }
</script>
